import { useState, useEffect } from 'react';
import { obtenerProductos } from '../services/productoService';

/**
 * Hook para obtener y gestionar productos
 * @returns {Object} { productos, loading, error, refetch }
 */
export const useProductos = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProductos = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await obtenerProductos({}, { withAuth: true });
      setProductos(data);
    } catch (err) {
      setError(err.message || 'No se pudieron cargar los productos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductos();
  }, []);

  return {
    productos,
    loading,
    error,
    refetch: fetchProductos,
  };
};

